<template>
    <v-btn class="iconTextColor--text" small text @click="$emit('click')">
        <v-icon medium class="pr-1"> {{ bIcon }}</v-icon>
        <slot></slot>
    </v-btn>
</template>


<script>

import VBtn from 'vuetify/lib/components/VBtn/';


export default
{
    name: 'IconTextButton',

    props: function()
    {
        let newProps = VBtn.options.props;
        newProps.bIcon = { type: String };
        return newProps;
    }(),

    data: () =>
    ({
        
    }),

    computed:
    {

    },


    mounted()
    {
        
    },

    methods:
    {
        
    }

}

</script>
